module.exports = __webpack_public_path__ + "static/img/PAULINA_JAIMES.bcd24fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/PAULINA_JAIMES.jpg
// module id = QUV6
// module chunks = 1